module.exports = __webpack_public_path__ + "img/partners_compact.47240c1d.png";